<template>
  <nav class="nav-root">
      
      <!-- Mobile menu -->
      <div class="nav__mobile__links" :class="{ 'open': isMobileMenuShowed }">
        <ul v-on:click.prevent="openCloseMenu">
          <router-link v-for="(item, index) in data.navigation" :key="index" :to="item.links" tag="li">
            <a :href="item.links">{{ item.name }}</a>
          </router-link>
        </ul>
      </div>
      <div class="container">
      
      <nav class="nav__mobile">
        <ul class="nav">
          <li>
            <a href="#" class="nav__mobile__menu" v-on:click.prevent="openCloseMenu" :class="{ 'open': isMobileMenuShowed }">
              <img src="../assets/menu.svg" alt="" class="icon__open">
              <img src="../assets/close.svg" alt="" class="icon__close">
            </a>
          </li>
          <!-- <router-link :to="'#'" v-on:click.prevent="openCloseMenu" tag="li">
          </router-link> -->

          <router-link :to="'/'"  tag="li">
            <a href="/" class="nav__mobile__logo">
              <img src="../assets/logo-simple.svg" alt="Twegos">
            </a>
          </router-link>
          
          <router-link :to="data.cta[0].url" tag="li">
            <a :href="data.cta[0].url" class="cta">{{ data.cta[0].text }}</a>
          </router-link>
        </ul>
      </nav>

      <!-- Desktop menu -->
      <nav class="nav__desktop">
          
          <!-- As the design navigation is a little tricky to render with a simple generated list
               we must construct them 'manually'.
          -->
          <ul>
            <li class="nav--3of10">
              <ul>
                <router-link :to="data.navigation[0].links" tag="li">
                  <a :href="data.navigation[0].links">{{ data.navigation[0].name }}</a>
                </router-link>

                
              </ul>
            </li>
            
            <!-- logo -->
            <li class="nav--4of10">
              <ul class="nav--logo">
                <router-link :to="'/'" tag="li">
                <a href="/">
                  <img src="../assets/logo-bw.svg" alt="Twegos">
                </a>
                </router-link>          
              </ul>
            </li>
            <!-- @end logo -->
            
            <li class="nav--3of10">
              <ul>
                 <li></li><li></li>

                  <!-- cta Get Started -->
                  <router-link :to="data.cta[0].url" tag="li">
                    <a :href="data.cta[0].url" class="cta">{{data.cta[0].text}}</a>
                  </router-link>
                  <!-- @end cta Get Started -->
              </ul>
            </li>
          </ul>
      </nav>
    </div>
  </nav>
</template>

<script>
import Common from '@/contents/common.json'

export default {
  name: 'SectionHeader',
  data () {
    return {
      'data': Common,
      isMobileMenuShowed: false
    }
  },
  methods: {
    openCloseMenu () {
      this.isMobileMenuShowed = !this.isMobileMenuShowed
    }
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Header.vue